
import { defineComponent, onMounted } from 'vue'
import useCart from '@/composables/useCart'
import useProducts from '@/composables/useProducts'

export default defineComponent({
  setup() {
    const { products, loadProducts } = useProducts()
    const { addItem } = useCart()

    onMounted(loadProducts)

    return {
      products,
      addItem,
    }
  },
})
